/**
 * Function to wrap mocked paths to setup the base url
 * https://github.com/mswjs/msw/issues/397#issuecomment-751230924
 */

export const baseURL = (path: string) =>
  new URL(path, window.BETCLOUD_ENV.REACT_APP_API_URL).toString();
